import { Section } from '@advanza/advanza_generic'
import PropTypes from 'prop-types'
import React from 'react'

class Restricted extends React.Component {
    constructor(props) {
        super(props)
        this.hasAccess = this.hasAccess.bind(this)
    }

    hasAccess(mode = 'r') {
        const { location } = this.props
        const permissions = window._user && window._user.permissions
        return permissions && permissions[location] && permissions[location][mode]
    }

    render() {
        const { showMessage, children, checkRead = true, checkWrite = true } = this.props

        if (checkRead && !this.hasAccess('r')) {
            if (showMessage) {
                return (
                    <Section x y className="restricted">
                        Restricted
                    </Section>
                )
            } else {
                return null
            }
        }

        const props =
            !checkWrite || this.hasAccess('w')
                ? {}
                : {
                      onClick: (e) => e.preventDefault(),
                      className: 'restricted-write-access',
                  }
        return <div {...props}>{children}</div>
    }
}

Restricted.propTypes = {
    location: PropTypes.string.isRequired,
    showMessage: PropTypes.bool,
    checkWrite: PropTypes.bool,
}

export default Restricted
